import React from 'react';

const FAQ_CONTENT = [
  {
    q: 'How long does it usually take to create a 3D model?',
    a: 'We deliver within 24 hrs for a single product. For projects of larger scale, we dedicate a designer and can create multiple products in a day.',
  },
  {
    q: 'I already have a CAD model of my product. Can it be added to Celestar?',
    a: 'Yes. We will still need to optimise it for the web and ensure consistency across all devices and hence charge a 50% of the modelling fee. The hosting subscription fee remains the same.',
  },
  {
    q: 'How do I add my product to Celestar?',
    a: 'We take care of the entire process from creation to adding it on the platform and provide you with the login details to monitor the analytics. Reach out to us to get started with the process.',
  },
];

class LandingFaqs extends React.Component {
  render() {
    return (
      <div id="landing-faq-content" className="landing-width-limit padding-lr-30">
        {FAQ_CONTENT.map(({ q, a }) => (
          <div className="landing-faq-item" key={q}>
            <h3 className="landing-faq-item-heading">{q}</h3>
            <p className="landing-faq-item-content">{a}</p>
          </div>
        ))}
      </div>
    );
  }
}

export default LandingFaqs;
